import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';

const INTRO_FLAG = 'intro_pending';

const IntroOverlay: React.FC = () => {
  const [visible, setVisible] = useState<boolean>(() => sessionStorage.getItem(INTRO_FLAG) === '1');
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!visible) return;
    sessionStorage.removeItem(INTRO_FLAG);

    const video = videoRef.current;
    if (!video) return;

    const tryPlay = async () => {
      try {
        video.muted = false;
        await video.play();
      } catch {
        video.muted = true;
        try {
          await video.play();
        } catch {
          setVisible(false);
        }
      }
    };

    tryPlay();
  }, [visible]);

  const finish = () => setVisible(false);

  const handleClick = () => {
    const video = videoRef.current;
    if (video && video.muted) {
      video.muted = false;
      localStorage.setItem('intro_sound_enabled', '1');
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="intro-overlay"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed inset-0 z-[9999] bg-black flex items-center justify-center"
          onClick={handleClick}>
          <video
            ref={videoRef}
            src="/intro.mp4"
            className="w-full h-full object-cover"
            playsInline
            autoPlay
            preload="auto"
            onEnded={finish}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default IntroOverlay;
